<template>
  <el-drawer
    v-model="showDrawer"
    ref="cleanEditDrawer"
    custom-class="r-drawer"
    :close-on-click-modal="false"
    @open="handleOpen"
    @close="handleClose"
  >
    <template #title>
      <div class="font-18 font-bold color-black">添加保洁任务</div>
    </template>

    <div class="clean-task-container">
      <div class="status-line m-b-5" v-if="!cleanTaskId">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">未开始</el-radio>
          <el-radio :label="2">保洁中</el-radio>
          <el-radio :label="3">已打扫</el-radio>
        </el-radio-group>
      </div>
      <p class="font-18">房源信息</p>
      <div class="room-info font-18">
        <div class="info-line">
          <span>房源：{{ `${info.parentProps.roomName}（${info.parentProps.roomTypeName}）` }}</span>
        </div>
        <div class="info-line">
          <span>日期：{{ info.fullDate }}</span>
        </div>
      </div>
      <p class="font-18">保洁任务</p>
      <div class="task-form">
        <el-form
          :model="formData"
          label-position="top"
          ref="formRef"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="时段" prop="taskEndTime">
                <el-time-picker
                  :editable="false"
                  v-model="taskTimeRange"
                  is-range
                  format="HH:mm"
                  value-format="HH:mm:ss"
                  range-separator="-"
                  :clearable="false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item class="m-l-10" label="保洁员" prop="staffId">
                <el-select v-model="formData.staffId" placeholder="不指定保洁员">
                  <el-option
                    v-for="item in cleanerList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
                <el-button class="m-l-5 border-btn primary" @click="addCleaner">添加</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="类型" prop="type">
                <el-select v-model="formData.type">
                  <el-option :value="1" label="简单"></el-option>
                  <el-option :value="2" label="标准"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="m-l-10" label="费用">
                <el-input-number
                  class="w-200"
                  v-model="formData.price"
                  :min="0"
                  controls-position="right"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" class="w-p-100">
            <el-input type="textarea" placeholder="填写备注信息" v-model.trim="formData.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="bottom-btn-container">
        <el-button class="plain-white" type="primary" @click="handleClose">关闭</el-button>
        <el-button class="color-orange" type="primary" @click="handleSave">确定</el-button>
      </div>
    </div>
    
    <RModal
      title="新增保洁人员"
      v-model="addCleanerModalShow"
      :closeOnClick="false"
      @change="addCleanerModalShow = false"
    >
      <template v-slot:content>
        <AddCleanerModal v-if="addCleanerModalShow" :storeId="storeId" @close="closeModal" />
      </template>
    </RModal>
  </el-drawer>
</template>

<script>
import { mapActions } from "vuex";
import RModal from '@/components/common/RModal'
import AddCleanerModal from '@/views/clean/cleanerManage/addCleanerModal'

export default {
  components: { RModal, AddCleanerModal },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({})
    },
    cleanTaskId: {
      type: [String, Number],
      default: ''
    },
  },
  emits: ['input', 'success'],
  data() {
    return {
      taskTimeRange: ['12:00:00', '14:00:00'],
      formData: {
        status: 1,
        roomId: null,
        taskStartTime: '',
        taskEndTime: '',
        staffId: null,
        type: 1,
        price: 80,
        remark: '',
        storeId: ''
      },

      showDrawer: false,

      cleanerList: [],
      addCleanerModalShow: false,
    };
  },
  created() {
    this.showDrawer = this.value;
  },
  watch: {
    value(val) {
      this.showDrawer = val;
    }
  },
  methods: {
    ...mapActions(["fetchData"]),
    // 获取保洁人员列表
    getCleanerList() {
      let url = 'CLEAN.CLEANER.GET_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: { storeId: this.info.storeId, pageSize: 9999, pageNumber: 1 }
      }).then(res => {
        this.cleanerList = res?.data || []
        if (this.cleanTaskId) {
          this.getDetail()
        }
      })
    },
    // 处理抽屉弹出
    handleOpen() {
      if (this.info.storeId) {
        for(let key in this.formData) {
          this.formData[key] = ''
        }

        this.taskTimeRange = ['12:00:00', '14:00:00']
        this.formData.status = 1
        this.formData.type = 1
        this.formData.price = 80
        this.formData.roomId = this.info.parentProps.roomId
        this.formData.storeId = this.info.storeId
        this.getCleanerList()
      }
    },
    // 详情
    getDetail() {
      this.fetchData({
        url: 'CLEAN.TASK.GET_DETAIL',
        method: 'get',
        params: { id: this.cleanTaskId }
      }).then(res => {
        if (res) {
          this.formData = res
        } else {
          this.$message.error('数据获取失败')
        }
      }).catch(err => {
        this.$message.error('数据获取失败')
      })
    },
    // 处理关闭弹层
    handleClose() {
      this.$emit("input", false);
      this.$refs.cleanEditDrawer.handleClose();
    },
    // 关闭添加保洁人员弹框
    closeModal($event) {
      this.addCleanerModalShow = false;
      if ($event === true) {
        this.getCleanerList();
      }
    },
    // 添加保洁人员
    addCleaner() {
      this.addCleanerModalShow = true;
    },
    // 提交
    handleSave() {
      this.formData.taskStartTime = this.info.fullDate + ' ' + this.taskTimeRange[0];
      this.formData.taskEndTime = this.info.fullDate + ' ' + this.taskTimeRange[1];
      let params = JSON.parse(JSON.stringify(this.formData))
      if (params.staffId === '' || params.staffId == null) delete params.staffId

      this.fetchData({
        url: 'CLEAN.TASK.POST_SAVE',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        params
      }).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.$emit("success");
          this.handleClose();
        } else {
          this.$message.error('操作失败')
        }
      }).catch(err => {
        this.$message.error('操作失败')
      })
    },
  },
};
</script>

<style lang="less" scoped>
@colorOrange: rgb(246, 100, 1);

.clean-task-container {
  position: relative;
  height: 100%;
}
.room-info {
  margin-bottom: 16px;
  padding: 17px 32px;
  background-color: rgb(241, 250, 255);
  border-radius: 3px;
  .info-line {
    margin-bottom: 10px;
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
}
.bottom-btn-container {
  position: absolute;
  bottom: 0px;
  margin: 0px -20px;
  padding: 21px 36px 0px 36px;
  text-align: right;
  width: calc(~"100% + 40px");
  box-shadow: 0px -6px 17px rgba(36, 176, 255, 0.13);
}

.plain-white {
  color: black;
  background-color: white;
  border: 1px solid #d9d9d9;
}
.color-orange {
  background-color: @colorOrange;
}
</style>